import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import type { FlatListTableProps, ListTableAction, ListTableColumn } from 'framework/ui/ui-builder';
import type { BuisnessFunctionListItem } from '../types';
import { BUISNESS_FUNCTION_STATE_LABELS } from '../constants';

const getColumns = (): ListTableColumn<BuisnessFunctionListItem>[] => [
  {
    id: 'name',
    label: 'Business function',
    width: 420,
    render: row => row.name,
  },
  {
    id: 'administrator',
    label: 'Administrator',
    width: 220,
    render: row => row.administrator,
  },
  {
    id: 'state',
    label: 'State',
    width: 150,
    render: row => BUISNESS_FUNCTION_STATE_LABELS[row.state],
  },
];

const getActions = (onEdit: (row: BuisnessFunctionListItem) => void): ListTableAction<BuisnessFunctionListItem>[] => [
  {
    id: 'edit-business-function',
    label: 'Edit business function',
    icon: <EditOutlinedIcon />,
    tooltip: 'Edit business function',
    variant: 'outlined',
    onClick: onEdit,
  },
];

export const getBuisnessFunctionTableConfig = (
  rows: BuisnessFunctionListItem[],
  actions: {
    onCreate: () => void;
    onEdit: (row: BuisnessFunctionListItem) => void;
  },
): FlatListTableProps<BuisnessFunctionListItem> => ({
  rows,
  withChildren: true,
  columns: getColumns(),
  mainAction: {
    id: 'create-business-function',
    label: 'Create business function',
    tooltip: 'Create business function',
    icon: <AddIcon />,
    variant: 'contained',
    onClick: actions.onCreate,
  },
  rowActions: { actions: getActions(actions.onEdit) },
  rowHeight: 46,
  emptyContent: 'No business functions found.',
});
